<template>
  <div>
    <div class="col-12 mt-2" v-if="book.chapters.length > 0">
      <p class="text-center">قسمت ها</p>
      <fvTable
        class="fv-size-lg"
        v-if="book.chapters.length > 0"
        :fields="fields"
        :rows="book.chapters"
      >
        <template slot="field-#" , slot-scope="scope">
          <span>{{ scope.index + 1 }}</span>
        </template>
        <template slot="field-نام کتاب" slot-scope="scope">
          {{ scope.row.bookName || "---" }}
        </template>
        <template slot="field-نام فصل" slot-scope="scope">
          <div v-html="scope.row.chapterName || '---'" />
        </template>
        <template slot="field-تاریخ ثبت" slot-scope="scope">
          {{ $dateTimeFormat(scope.row.createTime) }}
        </template>
        <template slot="field-actions" slot-scope="scope">
          <button
            @click="deleteChapter(scope.row.chapterId)"
            class="btn btn-warning btn-sm ml-2"
          >
            ویرایش
            <i class="far fa-edit" />
          </button>
          <button
            @click="deleteChapter(scope.row.chapterId)"
            class="btn btn-danger btn-sm"
          >
            حذف
            <i class="fa fa-trash" />
          </button>
        </template>
      </fvTable>
    </div>
    <div class="col-12 mt-2" v-else>
      <p class="text-center">این کتاب هیچ قسمتی ندارد.</p>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";

export default {
  data() {
    const { params } = this.$route;
    const { id } = params;
    return {
      id,
      fields: ["#", "نام کتاب", "نام فصل", "تاریخ ثبت", "actions"]
    };
  },
  props: ["book", "bookId"],
  methods: {
    async deleteChapter(chapterId) {
      try {
        const token = Vue.$cookies.get("accessToken");
        console.log("deleted ID", chapterId);
        const bookId = this.bookId;
        console.log("fucking bookId", bookId);
        const result = await axios.delete(
          `https://dev.api.ighe3.com/v5/panel/chapter/book/set/${bookId}/${chapterId}`,
          {
            headers: {
              Authorization: "Bearer " + token
            }
          }
        );
        console.log("deleted", result);
      } catch (error) {
        console.log(error);
      }
    }
  },
  created: {}
};
</script>
